package org.example.project.model

enum class AttackCellState {
    UNKNOWN,
    HIT,
    MISS,
    SCANNED_WATER,
    SCANNED_SHIP
}
